import { Method } from "./enums";

export const AAUTH = {
    login: ({ data }) => ({
        method: Method.POST,
        url: "/auth/sign-in",
        data: data,
    }),
    loginSSO: ({ data }) => ({
        method: Method.POST,
        url: "/auth/sso/sign-in",
        data: data,
    }),
    getProfile: () => ({
        method: Method.GET,
        url: "/profile",
    }),
    getAccessToken: ({ sessionId }) => ({
        method: Method.GET,
        url: `/auth/sso/access-token?session_id=${sessionId}`,
    }),
    forgotPassword: ({ data }) => ({
        method: Method.POST,
        url: "auth/forgot-password",
        data: data,
    }),
    checkEmail: ({ username }) => ({
        method: Method.GET,
        url: `users/email?username=${username}`,
    }),
    setNewPassword: ({ data }) => ({
        method: Method.POST,
        url: "auth/reset-password",
        data: data,
    }),
    verifyEmail: ({ data }) => ({
        method: Method.POST,
        url: "auth/confirm-field",
        data: data,
    }),
    tracking: ({ data }) => ({
        method: Method.POST,
        url: "/tracking-user",
        data,
    }),
    getTrackingByUser: ({ studentId, timeRange, type, isDaily }) => ({
        method: Method.GET,
        url: `/tracking-user/user/search?user_id=${studentId}${type ? `&tracking_user_type=${type}` : ""}&from_date=${timeRange.from}&to_date=${
            timeRange.to
        }&is_daily=${isDaily ?? false}`,
    }),
    getTracking: ({ studentId, timeRange, type }) => ({
        method: Method.GET,
        url: `/tracking-user/search?user_id=${studentId}&tracking_user_type=${type}&from_date=${timeRange.from}&to_date=${timeRange.to}`,
    }),
    updateProfile: ({ data }) => ({
        method: Method.PUT,
        url: "/profile",
        data,
    }),
    updatePassword: ({ data }) => ({
        method: Method.POST,
        url: "/profile/change-password",
        data,
    }),
    addEmail: ({ data }) => ({
        method: Method.POST,
        url: "/auth/add-email",
        data,
    }),
    adminResetPassword: ({ data }) => ({
        method: Method.POST,
        url: "/admin/users/set-password",
        data,
    }),
};
